export default "__VITE_ASSET__CSCJaBfE__"